import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Typography } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "./../../Utils"

const { Option } = Select;
const { Title } = Typography;

const StructureForm = props => {
  const [form] = Form.useForm();
  const [materialsTypes, setMaterialsTypes] = useState([]);
  const [functionsTypes, setFunctionsTypes] = useState([]);
  const isEditMode = props.isEditMode || false;
  const { t } = useTranslation();

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Load material and function types
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/structure-materials").then(({ data }) => {
        if (data) {
          setMaterialsTypes(data);
        }
      }).catch(function (error) {
        console.log(error);
      });
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/structure-functions").then(({ data }) => {
        setFunctionsTypes(data);
      }).catch(function (error) {
        console.log(error);
      });
  }, []);

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        structureFunction: props.record.asset.structureFunction,
        structureMaterial: props.record.asset.structureMaterial,
        age: props.record.asset.age,
        value: props.record.asset.value,
        dimension: props.record.asset.dimension,
        capacity: props.record.asset.capacity
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        structureFunction: props.record.asset.structureFunction,
        structureMaterial: props.record.asset.structureMaterial,
        age: props.record.asset.age,
        value: props.record.asset.value,
        dimension: props.record.asset.dimension,
        capacity: props.record.asset.capacity
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;

    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.structureFunction = elvis(values.structureFunction);
    newAsset.asset.structureMaterial = elvis(values.structureMaterial);
    newAsset.asset.age = elvis(values.age);
    newAsset.asset.value = elvis(values.value);
    newAsset.asset.dimension = elvis(values.dimension);
    newAsset.asset.capacity = elvis(values.capacity);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title
        className="details_form_header"
        title="Asset details"
        subTitle="Structure"
      />

      <Form.Item
        label="Function"
        name="structureFunction"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {functionsTypes.map(name => <Option key={name} value={name}>{t('farmEnums.structure_function.' + name, name)}</Option>)}
        </Select>
      </Form.Item>

      <Form.Item
        label="Material"
        name="structureMaterial"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {materialsTypes.map(name => <Option key={name} value={name}>{t('farmEnums.structure_material.' + name, name)}</Option>)}
        </Select>
      </Form.Item>

      <Form.Item
        label="Age"
        name="age"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Value (€)"
        name="value"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Dimension (mq)"
        name="dimension"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Capacity"
        name="capacity"
        rules={isEditMode ? [{ required: false }] : []}
        tooltip="Potential for holding, storing or accommodating goods"
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>
    </Form>
  );
};

export default StructureForm;